
export class AffinityPartnerUpsert {
    id: string = '';
    company_name ='';
    status='';
    affinity_partner_url='';
    referral_code='';

 }